module.exports = __webpack_public_path__ + "static/media/8800.49e538f8.jpg";